<template>
  <el-card class="box_card">
    <div class="content">
      <!-- 商品属性内容 -->
      <div class="content_left">
        <div class="ellipsis bold_font" style="font-size: 15px;">{{item.mbgi_goods_name }}</div>
        <div class="ellipsis" v-if="item.mbgi_goods_marker">品牌：{{ item.mbgi_goods_marker}}</div>
        <div v-else style="width: 10px;height: 10px;"></div>
        <div class="ellipsis">原价：<del>{{ item.mbgi_money_1}}</del>元</div>
        <div class="ellipsis">优惠价：{{ item.mbgi_money_2 }}元</div>
        <!-- <div style="font-size: 12px;">剩余{{ item.A }}份</div> -->
      </div>
      <!-- 商品图片 -->
      <div style="width: 80px;height: 80px;">
        <el-image v-if="item.mbgi_goods_img_path" style="width: 80px;height: 80px;" :src="item.mbgi_goods_img_path" @error="srcerr(item,$event)" />
      </div>
    </div>
    <div v-if="item.mbgi_money_3&&item.mbgi_money_3!='0'&&item.A!='0'" class="bottom">
      <div @click='phone_but(item,i)' class="pfp_btn btn1">
        <div>特惠价购买</div>
        <div style="font-size: 14px;color: #ffffff;">实付{{item.mbgi_money_3}}元</div>
      </div>
      <div @click='qr_code_but(item, i)' class="cir_btn btn1 center">
        优惠价购买</div>
    </div>

    <div v-if="item.mbds_status =='0'">
      <div class="bottom">
        <div @click='commodity_payment' class="fault">
          <span class="number">货道号{{item.gbs_number}}</span>
          货道故障
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="(!item.mbgi_money_3||item.mbgi_money_3=='0')&&item.A!='0'" class="bottom">
        <div @click='qr_code_but(item, i)' class="cir_btn btn1 center" style="width: 100%;">
          优惠价购买</div>
      </div>
      <div v-if="item.A=='0'" class="bottom">
        <div @click='commodity_payment' class="fault center">
          <span style="color: #ffffff; font-size: 12px;position: absolute;top: -15px; left: 10px;">货道号{{item.gbs_number}}</span>
          货道空了
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "card.vue",
  data () {
    return {

    }
  },
  props: ['item', 'i'],
  created () {

  },
  inject: ["qr_code_but", "phone_but", "commodity_payment"],
  methods: {}
}
</script>

<style scoped>
.box_card {
  width: 220px;
  height: 155px;
  padding: 0;
  margin: 0;
  border-radius: 10px;
}

.content {
  display: flex;
  width: 100%;
  height: 102px;
  overflow: hidden;
  padding: 8px 15px 0;
  justify-content: space-between;
  box-sizing: border-box;
}

.content_left {
  width: 150px;
  height: 80px;
  text-align: left;
}

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  font-size: 14px;
  line-height: 19px;
}

.bold_font {
  font-weight: 700;
}

.bottom {
  width: 100%;
  height: 60px;
  display: flex;
  margin-top: 2px;
}

.pfp_btn {
  font-size: 15px;
  background-color: rgb(246, 91, 71);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.btn1 {
  color: #ffffff;
  font-weight: 700;
  font-style: normal;
  width: 50%;
  height: 50px;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
}

.cir_btn {
  font-size: 17px;
  background-color: rgb(251, 140, 94);
}

.fault {
  position: relative;
  color: rgb(217, 0, 27);
  line-height: 60px;
  font-weight: 700;
  font-style: normal;
  font-size: 17px;
  width: 100%;
  height: 50px;
  background-color: rgb(170, 170, 170);
}

.fault_number {
  color: #ffffff;
  font-size: 12px;
  position: absolute;
  top: -15px;
  left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/components/card.vue